import { sanitizePromptAsFilename } from '@cartwhl/common/utils/sanitizePromptAsFilename';
import { trackOutputExported } from '@cartwhl/common/utils/trackOutputExported';

import { noticesStore } from 'stores';

export const exportAnimationFile = (
  href: string,
  extension: string,
  prompt?: string,
) => {
  if (href) {
    let filename = `Cartwheel-export.${extension}`;
    if (prompt) {
      const sanitizedPrompt = sanitizePromptAsFilename(prompt, 50);
      filename = `Cartwheel-${sanitizedPrompt}.${extension}`;
    }
    const aTag = document.createElement('a');
    aTag.href = href;
    aTag.download = filename;
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
    noticesStore.success('Download has begun!');
    trackOutputExported({
      eventSource: 'studio',
      app: 'studio',
      format: extension,
      fileCount: 1,
    });
  }
};
